import { isEmpty } from '@jjj/components';
import moment from 'moment';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';
import { keyBy } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';
import { withTZ } from '../../../../../../helpers/dateTime';

const initState = {
  editForm: null,
  loading: false,
  total: 0,
};

function validate(attr, value, valueToCompare) {
  let error = '';
  const startAtValue = attr === 'started_at' && value;

  if (attr === 'started_at') {
    if (isEmpty(value)) {
      error = t('dash.validation.choose_a_field', { fieldName: t('dash.jobs.bookings.start_date') });
    } else if (startAtValue && withTZ(startAtValue).isSameOrAfter(withTZ(valueToCompare))) {
      return t('dash.validation.start_time_error');
    }
  }

  if (attr === 'finished_at') {
    if (isEmpty(value)) {
      error = t('dash.validation.choose_a_field', { fieldName: t('dash.jobs.bookings.end_date') });
    }
  }

  return error;
}

function onLoad(state, { payload }) {
  return {
    ...state,
    loading: false,
    editForm: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

function onSaveSuccess(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value, booking } = payload;
  const { editForm } = state;

  const valueToCompare = attr === 'started_at' ? moment.utc(booking?.finishes_at) : null;

  editForm[attr] = {
    value,
    error: validate(attr, value, valueToCompare),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CANCEL]: onCancel,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.TOUCH]: onTouch,
});
